import React from "react";
import {CircularProgress, IconButton, Tooltip} from "@material-ui/core";
import AIAssistantIcon from "view/images/AIAssistantIcon";
import useStyles from "./styles";

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  tooltip?: string;
  id?: string;
};

const AiTranslateButton = ({
  onClick,
  disabled,
  isLoading,
  tooltip = "Generate translation with AI",
  id,
}: Props) => {
  const classes = useStyles();

  const button = (
    <IconButton
      id={id}
      className={classes.aiButton}
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      {isLoading ? (
        <CircularProgress size={20} />
      ) : (
        <AIAssistantIcon disabled={disabled} />
      )}
    </IconButton>
  );

  // MUI v4 tooltips do not fire on disabled children, hence the wrapper span.
  return (
    <Tooltip title={tooltip}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default AiTranslateButton;
